// extracted by mini-css-extract-plugin
export default {"base":"vp_tqZw4","tool":"vp_klmLz","specific":"vp_X9gNv"};